import { Route, Outlet } from "react-router-dom";
import AdminLayout from "../../layout/app/admin/AdminLayout";
import CatalogLayout from "../../layout/app/admin/CatalogLayout";
import ProviderGroupLayout from "../../layout/app/admin/ProviderGroupLayout";
import ProviderGroupPatients from "../../pages/app/ProviderGroupPatients";
import AdminDashboard from "../../pages/app/admin/AdminDashboard";
import DataImport from "../../pages/app/admin/library/DataImport";
import CatalogCPTCodeCatalog from "../../pages/app/admin/library/catalog/CatalogCPTCodeCatalog";
import CatalogDiagnosisCodeCatalog from "../../pages/app/admin/library/catalog/CatalogDiagnosisCodeCatalog";
import CatalogDrugCatalog from "../../pages/app/admin/library/catalog/CatalogDrugCatalog";
import CatalogHCPCSCodeCatalog from "../../pages/app/admin/library/catalog/CatalogHCPCSCodeCatalog";
import CatalogLOINCCodeCatalog from "../../pages/app/admin/library/catalog/CatalogLOINCCodeCatalog";
import FormBuilderHost from "../../pages/app/admin/library/form-builder/FormBuilderHost";
import FormBuilderTable from "../../pages/app/admin/library/form-builder/FormBuilderTable";
import NewTemplateTable from "../../pages/app/admin/library/templates/NewTemplateTable";
import TemplateNewForm from "../../pages/app/admin/library/templates/TemplateNewForm";
import ProviderGroupDepartments from "../../pages/app/admin/provider-groups/ProviderGroupDepartments";
import ProviderGroupLocations from "../../pages/app/admin/provider-groups/ProviderGroupLocations";
import ProviderGroupProfile from "../../pages/app/admin/provider-groups/ProviderGroupProfile";
import ProviderGroupProviders from "../../pages/app/admin/provider-groups/ProviderGroupProviders";
import ProviderGroupStaffUsers from "../../pages/app/admin/provider-groups/ProviderGroupUsers";
import ProviderGroupsLayout from "../../pages/app/admin/provider-groups/ProviderGroups";
import AuditLog from "../../pages/app/admin/settings/AuditLog";
import AdminProfile from "../../pages/app/admin/settings/Profile/AdminProfile";
import AdminUser from "../../pages/app/admin/tenant-settings/AdminUsers";
import RolesAndResponsibilities from "../../pages/app/admin/tenant-settings/RolesAndResponsibilities";
import TenantConfiguration from "../../pages/app/admin/tenant-settings/tenant-configuration";
import TenantProviders from "../../pages/app/admin/tenant-settings/tenant-providers";
import { ProtectedRoute } from "../Router";
import ProviderConfig from "../../pages/app/provider/settings/ProviderConfig";

export const AdminRoute = () => {
  return (
    <Route
      element={
        <ProtectedRoute accessingViewAs="admin">
          <AdminLayout />
        </ProtectedRoute>
      }
    >
      <Route index path="dashboard" element={<AdminDashboard />} />
      <Route path="provider-groups">
        <Route index element={<ProviderGroupsLayout />} />
        {/* future reference while you need page rather than modal */}
        {/* <Route path="location-id" element={<ProviderLocationIdLayout />}>
                <Route index element={<LocationDetails />} />
                <Route path="department" element={<LocationDepartment />} />
                <Route path="patient" element={<LocationPatient />} />
                <Route path="user" element={<LocationUser />} />
              </Route> */}
        {/* <Route path="users" element={<ProviderGroupUsersLayout />}>
                <Route path="staff/:staffId" element={<StaffUser />} />
                <Route path="provider/:providerId" element={<ProviderUser />} />
              </Route> */}
        <Route path=":providerGroupId/:uuid" element={<ProviderGroupLayout />}>
          <Route index element={<ProviderGroupProfile />} />
          <Route path="locations" element={<ProviderGroupLocations />} />
          <Route path="departments" element={<ProviderGroupDepartments />} />
          <Route path="patients" element={<ProviderGroupPatients />} />
          <Route path="users" element={<ProviderGroupStaffUsers />} />
          <Route path="providers" element={<ProviderGroupProviders />} />
          <Route path="configuration" element={<ProviderConfig />} />
        </Route>
      </Route>
      <Route path="library">
        <Route index element={<DataImport />} />
        <Route path="catalog" element={<CatalogLayout />}>
          <Route index element={<CatalogLOINCCodeCatalog />} />
          <Route path="drug-catalog" element={<CatalogDrugCatalog />} />
          <Route
            path="diagnosis-catalog"
            element={<CatalogDiagnosisCodeCatalog />}
          />
          <Route path="cpt-code-catalog" element={<CatalogCPTCodeCatalog />} />
          <Route
            path="hcpcs-code-catalog"
            element={<CatalogHCPCSCodeCatalog />}
          />
        </Route>
        <Route path="form-builder-list" element={<FormBuilderTable />} />
        <Route path="form-builder-host" element={<FormBuilderHost />} />
        <Route path="templates-list" element={<NewTemplateTable />} />
        <Route path="templates-host" element={<TemplateNewForm />} />
      </Route>

      <Route path="settings">
        <Route index element={<AdminProfile />} />
        <Route path="audit-log" element={<AuditLog />} />

        <Route
          path="roles-responsibility"
          element={<RolesAndResponsibilities />}
        />
      </Route>

      <Route path="tenant-settings">
        <Route index element={<TenantProviders />} />
        <Route path="admin-users" element={<Outlet />}>
          <Route index element={<AdminUser />} />
        </Route>
        <Route path="tenant-configuration" element={<TenantConfiguration />} />
      </Route>
    </Route>
  );
};
